import React, { Suspense } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import { PropTypes } from "prop-types";

import { withI18n } from "../../../i18n/useI18n";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import * as actions from "./actions";
import css from "./trendAnalysisMagneticStyle.less";
import AppHOC from "../../../generics/AppHOC";
import Spinner from "../../../common/Spinner";

const ErrorComponent = React.lazy(() =>
  import("../../../common/ErrorComponent")
);
import FilterView from "./FilterView";
import OverallTrendView from "./OverallTrendView";
import ApplicationsTable from "../../applications/ApplicationsTableView/AppTable";
import SelectedAppView from "./SelectedAppView";

const [HbrCard, HbrRadioGroup, HbrRadio] = reactWrapper([
  "hbr-card",
  "hbr-radio-group",
  "hbr-radio"
]);

const mapStateToProps = state => ({
  trend: state.vanalytics.trend
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

class TrendAnalysis extends React.Component {
  constructor(props) {
    super(props);
    const { tViews } = this.props.i18n;
    this.state = {
      selectedList: this.props.globalFilter.selected_apps,
      radioGroup: [
        {
          value: "bandwidth",
          text: tViews('trendAnalysisTop'),
          checked: true
        },
        {
          value: "custom",
          text: tViews('trendAnalysisCustomList'),
          checked: false
        }
      ]
    };
    this.radioValue = "bandwidth";
  }

  componentWillUnmount() {
    this.props.setSelectedAppList(
      this.props.globalFilter.selected_apps_default
    );
  }

  onRadioChange = e => {
    const { tViews } = this.props.i18n;
    const newValue = this.state.radioGroup.map(radio => {
      if (radio.value === e.target.value) {
        radio.checked = true;
        // Update text with current translation
        radio.text = radio.value === "bandwidth" 
          ? tViews('trendAnalysisTop') 
          : tViews('trendAnalysisCustomList');
      } else {
        radio.checked = false;
        // Update text with current translation
        radio.text = radio.value === "bandwidth" 
          ? tViews('trendAnalysisTop') 
          : tViews('trendAnalysisCustomList');
      }
      return radio;
    });
    const selectedName = e.target.value;
    if (selectedName === "bandwidth") {
      this.props.setSelectedAppList(
        this.props.globalFilter.selected_apps_default
      );
    }
    this.radioValue = selectedName;
    this.setState({ radioGroup: newValue });
  };

  onCustomListChange(selections) {
    this.setState({ selectedList: selections });
  }

  render() {
    const { tViews } = this.props.i18n;
    const { selectionError } = this.props.trend.error;
    return (
      <div className={css["trend-analysis"]}>
        <div className="trend-ctr-content">
            <FilterView />
            <OverallTrendView />
          <div>
            <HbrCard
              container={true}
              className="application-trend-analysis-hbr-card"
            >
                <div className="hbr-type-h2 trend-applicaiton-title-bottom" data-testid="trendTitle">
                  {tViews('trendAnalysisApplication')}
                </div>

                <HbrRadioGroup data-testid="trendRadioButton" onHbr-click={this.onRadioChange}>
                  {this.state.radioGroup.map((radio, i) => {
                    const { text, ...props } = radio;
                    return (
                      <HbrRadio key={i} {...props}>
                        {text}
                      </HbrRadio>
                    );
                  })}
                </HbrRadioGroup>
              {selectionError ? (
                <div className="error_components">
                  <Suspense fallback={<Spinner />}>
                    <ErrorComponent
                      {...selectionError}
                      width={"200px"}
                      className={"super-small-dashlet-error"}
                    />
                  </Suspense>
                </div>
              ) : (
                <div>
                  {this.radioValue === "custom" ? (
                    <div className={css["custom-list-view"]}>
                      <ApplicationsTable rowSelect />
                    </div>
                  ) : null}
                  <SelectedAppView
                    selectedList={this.state.selectedList}
                    isCustom={this.radioValue === "custom"}
                  />
                </div>
              )}
            </HbrCard>
          </div>
        </div>
      </div>
    );
  }
}

TrendAnalysis.propTypes = {
  actions: PropTypes.object.isRequired,
  globalFilter: PropTypes.object.isRequired,
  trend: PropTypes.object.isRequired,
  setSelectedAppList: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(AppHOC(withI18n(TrendAnalysis)))
);
